import { formatDate, parseJSON } from 'utils/common'

export const ModelOrder = (obj = {}) => {
	return {
		orderId: obj.orderId || '',
		orderExternalId: obj?.orderExternalId || '',
		createDate: formatDate(obj?.createDate, 'MM/DD/YYYY') || '',
		currency: obj?.currency || '',
		defaultCurrency: obj?.defaultCurrency || '',
		price: obj?.price || '',
		isOpen: obj.isOpen || false,
		count: 0,
		items:
			obj?.items?.map((item) => ({
				shopId: obj?.shopId || undefined,
				returned: item?.returned,
				pending: item?.pending,
				imageUrl: parseJSON(item?.productVariant?.imageUrl) || [],
				quantity: item?.quantity || '',
				name: item.name || '',
				currency: item.currency || obj?.currency,
				orderId: item.orderId || '',
				orderItemExternalId: item.orderItemExternalId || '',
				orderExternalId: obj.orderExternalId || '',
				orderItemId: item.orderItemId || '',
				price: item.price || '',
				attributes: parseJSON(item?.productVariant?.attributes) || [],
				returnActions: item?.returnActions || [],
			})) || [],
	}
}
